import { OperationLogComponent } from './operation-log.component';
export var operationLogRoutes = [
    {
        path: 'operation-log',
        component: OperationLogComponent,
        data: {
            'expectedRoles': ['Admin', 'IT']
        },
    }
];
var OperationLogRoutingModule = (function () {
    function OperationLogRoutingModule() {
    }
    return OperationLogRoutingModule;
}());
export { OperationLogRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/operation-log/operation-log-routing.module.ts.pre-build-optimizer.js